import { c as _c } from "react/compiler-runtime";
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import type { PropsWithChildren } from 'react';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';
import { cx } from '../cx';
export type BadgeProps = {
  testid?: string;
  className?: string;
  animationKey?: number;
} & VariantProps<typeof variants>;
const variants = tv({
  base: 'font-base-caption grid place-content-center rounded-full px-1 leading-tight',
  variants: {
    size: {
      xs: 'bg-primary-red box-border size-2 border border-white p-0 text-white',
      small: 'text-primary size-4 bg-white',
      large: 'bg-primary-red min-h-4 min-w-4 border border-white text-white'
    },
    dark: {
      true: 'bg-primary text-white'
    }
  },
  defaultVariants: {
    size: 'large'
  }
});
export const Badge = t0 => {
  const $ = _c(34);
  const {
    children,
    className,
    testid,
    size,
    dark,
    animationKey
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== animationKey || $[1] !== children || $[2] !== className || $[3] !== dark || $[4] !== size || $[5] !== testid) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const styles = variants({
        size,
        dark
      });
      if (animationKey === undefined) {
        t8 = <span className={cx(styles, className)} data-testid={testid}>{children}</span>;
        break bb0;
      }
      T1 = AnimatePresence;
      t7 = "wait";
      T0 = m.span;
      t1 = animationKey;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          scale: 1.3
        };
        t3 = {
          scale: 1
        };
        t4 = {
          scale: 1.3
        };
        t5 = {
          duration: 0.3
        };
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
      } else {
        t2 = $[16];
        t3 = $[17];
        t4 = $[18];
        t5 = $[19];
      }
      t6 = cx(styles, className);
    }
    $[0] = animationKey;
    $[1] = children;
    $[2] = className;
    $[3] = dark;
    $[4] = size;
    $[5] = testid;
    $[6] = T0;
    $[7] = T1;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    T0 = $[6];
    T1 = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[20] !== T0 || $[21] !== children || $[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== testid) {
    t9 = <T0 key={t1} initial={t2} animate={t3} exit={t4} transition={t5} className={t6} data-testid={testid}>{children}</T0>;
    $[20] = T0;
    $[21] = children;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = testid;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== T1 || $[31] !== t7 || $[32] !== t9) {
    t10 = <T1 mode={t7}>{t9}</T1>;
    $[30] = T1;
    $[31] = t7;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};